<template>
    <flex-line :show-border="true">
        <label class="title">{{title}}</label>
        <div slot="right">
            <label class="subtitle discount" v-if="discount">{{subtitle}} {{ $t('general.point_unit') }}</label>
            <label class="subtitle" v-else>{{subtitle}} {{ $t('general.point_unit') }}</label>
        </div>
    </flex-line>
</template>

<script>
import flexLine from '../../../flexLine'
export default {
  props: {
    title: {
    },
    subtitle: {
    }
  },
  components: {
    flexLine
  }
}
</script>

<style lang="scss" scoped>
    .title {
        width: 5rem;
        font-size:$subFontSize;
        color: #333;
    }
    .subtitle {
        flex: 1;
        margin-left: 1rem;
        color: #333;
        font-size:$h3;
        text-align: right;
    }
    .subtitle.discount{color:$primaryColor}
</style>
